// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1zZU_","col":"CardReaderDesc_col__3yzgO","label":"CardReaderDesc_label__2VSew"};